module.exports = __webpack_public_path__ + "img/alert.86854dab.svg";